import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-7 w-9/12 md:w-80 lg:w-96" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-72 md:h-96 mt-9 md:pr-8 lg:pr-16 md:w-11/12" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-4 w-full mt-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-4 w-full mt-14" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-4 w-full mt-14" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton px-4 h-4 mr-2 w-full mt-12" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton px-4 h-4 mr-2 mt-8 w-full" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton mt-8 h-4 w-2/6" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createBlock(_component_Grid, null, {
    default: _withCtx(() => [
      _createVNode(_component_Column, { span: [ 2, 3, 4 ] }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        span: [ 2, 2 ],
        class: "mt-16"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}